/**
 * The two public store listings, in one place.
 *
 * These are here rather than inline in `AppStoreBadges` because they are facts about the
 * product, not about a component, and because the badge renders on four surfaces — a wrong
 * URL inlined four times is four fixes.
 *
 * **Where the values come from.** The Play URL is fully determined by the `applicationId`
 * (`capacitor.config.ts` → `appId`, `android/fastlane/Appfile` → `package_name`); Play has no
 * separate numeric listing id. Apple does, and it is nowhere in the build config: `6796540563`,
 * recorded in `src/docs/APP_STORE_CONNECT_STATE.md` and confirmed on 2026-09-03 against the
 * public lookup API — `https://itunes.apple.com/lookup?bundleId=com.gotradeloop.mobile` returns
 * `trackId: 6796540563`, `trackName: "Trade Loop Network"`, version 1.0.3.
 *
 * **The listing name is `Trade Loop Network`, not `Trade Loop`** — plain "Trade Loop" was taken
 * on the App Store, and the Play listing was named to match (see
 * `src/docs/ANDROID_PLAY_SUBMISSION.md`). Accessible link names use the listed name so that what
 * a screen reader announces is what the user will see when the store page opens.
 *
 * Both are overridable at build time (`VITE_APP_STORE_URL` / `VITE_PLAY_STORE_URL`) so a preview
 * or staging deploy can point elsewhere. Setting one to an empty string is meaningful: the badge
 * for that store is dropped rather than shipped as a dead link.
 */

/** Name both listings are published under. */
export const STORE_LISTING_NAME = 'Trade Loop Network';

export const APP_STORE_URL =
  import.meta.env.VITE_APP_STORE_URL ??
  'https://apps.apple.com/us/app/trade-loop-network/id6796540563';

export const PLAY_STORE_URL =
  import.meta.env.VITE_PLAY_STORE_URL ??
  'https://play.google.com/store/apps/details?id=com.gotradeloop.mobile';
